import { render, staticRenderFns } from "./ProjectCommentThread.vue?vue&type=template&id=37c2271e"
import script from "./ProjectCommentThread.vue?vue&type=script&lang=js"
export * from "./ProjectCommentThread.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports